import { WorkspaceConfigDto } from "../dto"
import WorkspaceConfig from "./WorkspaceConfig"
import { WorkspaceContext } from "../WorkspaceContext"

export class WorkspaceConfigContext implements WorkspaceContext {
  constructor(
    readonly workspace: WorkspaceConfig,
    readonly modifiedAt: string | null,
    readonly dto: WorkspaceConfigDto
  ) {}

  static of(dto: WorkspaceConfigDto, modifiedAt: string | null): WorkspaceConfigContext {
    return new WorkspaceConfigContext(WorkspaceConfig.from(dto, modifiedAt), modifiedAt, dto)
  }
}

export interface WorkspaceConfigStorage {
  get(): WorkspaceConfigContext | null

  set(config: WorkspaceConfigContext): void

  clear(): void
}

export class NoopWorkspaceConfigStorage implements WorkspaceConfigStorage {
  get(): null {
    return null
  }

  set(config: WorkspaceConfigContext): void {}

  clear(): void {}
}
